var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import * as PropTypes from "prop-types";
import FullModal from "@irati/ui/src/FullModal";
import id from "@irati/utils/id";
import { RouterLink } from "@irati/ui/src/Link";
import { IconButton, IconTypes } from "@irati/ui/src/Button";
import { CompanyValuesCreateEdit, CompanyValuesList } from "../../components/Settings/CompanyValues";
import { BackArrowContainer } from "./styled";
import { SETTINGS_CUSTOMISE_VALUES } from "../../routes/routeConfig";
var CompanyValuesBasic = /** @class */ (function (_super) {
    __extends(CompanyValuesBasic, _super);
    function CompanyValuesBasic() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            show: false,
            companyValue: null
        };
        _this.show = function (companyValue) {
            _this.setState({ show: true, companyValue: companyValue });
        };
        _this.hide = function () {
            var _a = _this.props, setupView = _a.setupView, setIsStepCompletable = _a.setIsStepCompletable;
            if (setupView && setIsStepCompletable) {
                setIsStepCompletable(true);
            }
            _this.setState({ show: false, companyValue: null });
        };
        return _this;
    }
    CompanyValuesBasic.prototype.render = function () {
        var setupView = this.props.setupView;
        var _a = this.state, show = _a.show, companyValue = _a.companyValue;
        var apps = this.context.apps;
        var idNamespace = id("company-values-basic", this.props);
        return (React.createElement(Row, null,
            !setupView && (React.createElement(BackArrowContainer, { md: 1 },
                React.createElement(RouterLink, { to: SETTINGS_CUSTOMISE_VALUES, app: apps.ADMIN },
                    React.createElement(IconButton, { icon: IconTypes.chevronLeft })))),
            React.createElement(Col, { md: 11 },
                React.createElement("div", { id: idNamespace },
                    React.createElement(CompanyValuesList, { setupView: setupView, onClick: this.show }),
                    React.createElement(FullModal, { id: idNamespace, onHide: this.hide, show: show },
                        React.createElement(CompanyValuesCreateEdit, { onSuccess: this.hide, companyValue: companyValue }))))));
    };
    CompanyValuesBasic.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    return CompanyValuesBasic;
}(Component));
export default CompanyValuesBasic;
